import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemButton, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";
import ListItemIcon from "@mui/material/ListItemIcon";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { NavbarContainer } from "./style";

const Navbar = ({ open }) => {

  const navList = [
    {
      label: "Dashboard",
      to: "/onboarding/admin",
      icon: <DashboardIcon />,
      showItem: true,
    },
    // {
    //   label: "Profile",
    //   to: "/onboarding/profile",
    //   icon: <AccountBoxIcon />,
    //   showItem: true,
    // },
  ];

  const renderByType = (eachItem) => {
    return (
      <div>
        <ListItem
          key={eachItem.label}
          component={eachItem.to ? NavLink : undefined}
          to={eachItem.to ? eachItem.to : undefined}
          style={{ cursor: `${eachItem.link && "pointer"}`, padding: "0" }}
          onClick={eachItem.onClick}
        >
          <ListItemButton
            sx={{
              minHeight: 48,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 3 : "auto",
                justifyContent: "center",
              }}
            >
              {eachItem.icon}
            </ListItemIcon>
            <ListItemText
              primary={eachItem.label}
              sx={{ opacity: open ? 1 : 0 }}
            />
          </ListItemButton>
        </ListItem>
      </div>
    );
  };

  return (
    <NavbarContainer>
      {navList.map((eachItem) => {
        return (
          <>
            <div>{renderByType(eachItem)}</div>
          </>
        );
      })}
    </NavbarContainer>
  );
};

export default Navbar;

Navbar.propTypes = {
  open: PropTypes.bool.isRequired,
};
